import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

class OnStageLogo extends React.Component{

    componentDidMount() {
        if (this.props.popUpMenu.expanded || this.props.popUpMenu.close) {
            this.logo.style.opacity = 0
            this.logo.style.pointerEvents = 'none'
        } else if (this.logo.style.opacity === '0') {
            this.logo.style.opacity = 1
            this.logo.style.pointerEvents = 'auto'
        }
    }
          
    componentDidUpdate() {
        if (this.props.popUpMenu.expanded || this.props.popUpMenu.close) {
            this.logo.style.opacity = 0
            this.logo.style.pointerEvents = 'none'
        } else if (this.logo.style.opacity === '0') {
            this.logo.style.opacity = 1
            this.logo.style.pointerEvents = 'auto'
        }
    }
    
    render(){   
        let logo = require('../../resources/isotipo_B.png')

        return (
            <div>
                <div className='logo-background' ref={ref => this.logo = ref}>
                    <Icon path={ mdiClose } size='30px' color='white' style={{margin: 10}}/>
                    <img className="popup-menu-logo" src={logo} alt="logo" onClick={ this.props.handleClick }/>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu 
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(OnStageLogo)